// The client record's Details field set (CR.4 as amended by decision 18, bug #5640):
// the full existing CRM field set per production (SRS §6.3.1) PLUS the wizard step-1
// onboarding fields — a superset, never a 1:1 mirror of step 1. Onboarding capture and
// CRM record maintenance are separate processes over these shared values.
//
// No "required" rules: completion gating belongs to the wizard, and the Details page
// never blocks an edit or navigation on a missing value. Format rules (url, numeric)
// are kept so a malformed value is reported inline instead of being saved.
export const fields = {
  companyName: {
    label: "Company Name",
    type: "text",
  },
  clientStatusID: {
    label: "Status",
  },

  // Step-1 additions.
  companyCode: {
    label: "Company Code",
    type: "text",
  },
  countryCode: {
    label: "Country",
  },
  subDivisionCode: {
    label: "Sub/Division Code",
    type: "text",
    // Uppercased as typed (S1.1).
    observers: [
      {
        key: "value",
        call: ({ field }) => {
          const upper = (field.value || "").toUpperCase();
          if (upper !== field.value) field.set("value", upper);
        },
      },
    ],
  },

  // Retained CRM field set.
  franchiseID: {
    label: "TDDA Supporting Region",
  },
  franchiseOfficeID: {
    label: "TDDA Supporting Clinic",
  },
  // Retained so the existing CRM value still round-trips through the form (bug 5640 guard). The
  // record renders the Client Type below instead — National, Regional or SSO since D12 (story
  // 6348) — and the server mirrors it back to this column (S1.8, bug 5705).
  companyType: {
    label: "National/Regional",
  },
  clientType: {
    label: "Client Type",
    value: null,
  },
  headOfficePhone: {
    label: "Head Office Phone",
  },
  // Named for what it records — which TDDA business units the client belongs to — so it no longer
  // reads as the same question as step 2’s service line, which is what made the two look like one
  // unmerged field (task 5725). Both may be ticked; step 2 seeds its own answer from this.
  vendorTypeIDs: {
    label: "TDDA / HealthTick client",
    value: [],
  },
  specialPricing: {
    label: "Special Pricing",
    value: false,
  },
  industryID: {
    label: "Industry",
  },
  website: {
    label: "Website Url",
    rules: "string|url",
    placeholder: "https://",
  },
  totalStaffNumber: {
    label: "Total Employee Numbers",
    rules: "numeric",
    placeholder: "100",
    type: "number",
  },
  leadTypeID: {
    label: "Lead Type",
  },
  serviceTypeIDs: {
    label: "Services",
    value: [],
  },
  primaryCompanyRelationshipManager: {
    label: "TDDA Primary Relationship Manager",
    value: null,
  },
  healthTickPrimaryRelationshipManager: {
    label: "Health Tick Primary Relationship Manager",
    value: null,
  },
  additionalCompanyRelationshipManagers: {
    label: "TDDA Additional Relationship Manager(s)",
    value: [],
  },
  tddaAttachments: {
    label: "TDDA Attachment",
    value: [],
  },
  healthTickAttachments: {
    label: "HealthTick Attachment",
    value: [],
  },

  // Editable while the client is still onboarding, derived and read-only once it is a current
  // client (bug 5716). The numeric rule applies either way — it can only ever hold a figure.
  salesTotalValue: {
    label: "Sales Pipeline Value",
    type: "text",
    rules: "numeric",
  },
  dealStatusID: {
    label: "Deal Stage",
    value: null,
  },
  // The derived summary, shown once the figures come from the deals.
  dealStage: {
    label: "Deal Stage",
  },
  createdByOn: {
    label: "Created By/Created On",
  },
  modifiedByOn: {
    label: "Modified By/Modified On",
  },
  importedByOn: {
    label: "Imported By/Imported On",
  },
};
